import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon'; // if your template uses <mat-icon>
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';

import { TogglTimerButtonComponent } from './toggl-timer-button.component';

@NgModule({
    declarations: [
        TogglTimerButtonComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        TooltipModule,
    ],
    exports: [
        TogglTimerButtonComponent
    ]
})
export class TogglTimerButtonModule {}
